export default __webpack_public_path__ + "static/media/image-35.50e2ffb1.png";